"use client";

import { useInView } from "motion/react";
import { type RefObject, useRef } from "react";

import { useIntroDone } from "@/components/motion/stage";

// =============================================================================

type InViewMargin = NonNullable<Parameters<typeof useInView>[1]>["margin"];

/**
 * Entrance trigger: true once the element has entered the viewport AND the
 * intro preloader has lifted, so that nothing plays under the curtain on a
 * first visit.
 */
export function useReveal<T extends Element>(
  margin: InViewMargin = "0px 0px -8% 0px"
): { ref: RefObject<T | null>; isRevealed: boolean } {
  const ref = useRef<T>(null);
  const isInView = useInView(ref, { once: true, margin });
  const introDone = useIntroDone();
  return { ref, isRevealed: isInView && introDone };
}

// =============================================================================
